import { useState } from 'react';
import { useEquipmentSearch } from '@/equipments/presentation/hooks/useEquipmentSearch';
import { CrewField, SelectedEquipment } from '../RaptorJobCreateModal';
import { JOB_FORM_STEPS, type JobFormStepType } from '@/raptorjob/domain/constants/jobFormLabels';

export const useRaptorJobCreateModal = () => {
  const [step, setStep] = useState<JobFormStepType>(JOB_FORM_STEPS.JOB_INFO);
  const [hasUnavailableResources, setHasUnavailableResources] = useState(false);
  const [showResourceUnavailabilityWarningModal, setShowResourceUnavailabilityWarningModal] = useState(false);

  // Search terms for job info autocompletes
  const [jobSiteSearchTerm, setJobSiteSearchTerm] = useState('');
  const [selectedCustomerName, setSelectedCustomerName] = useState('');

  // Search terms for resources autocompletes
  const [crewFields, setCrewFields] = useState<CrewField[]>([]);
  const [selectedEquipment, setSelectedEquipment] = useState<SelectedEquipment | null>(null);
  const [selectedClass, setSelectedClass] = useState<{ id?: string | number | null; name?: string | null } | null>(null);
  const [selectedType, setSelectedType] = useState<{ id?: string | number | null; name?: string | null } | null>(null);
  const [selectedSize, setSelectedSize] = useState<{ id?: string | number | null; name?: string | null } | null>(null);
  const {
    searchTerm: equipmentSearchTerm,
    debouncedSearchTerm: equipmentDebouncedSearchTerm,
    setSearchTerm: setEquipmentSearchTerm
  } = useEquipmentSearch();

  return {
    step,
    setStep,
    hasUnavailableResources,
    setHasUnavailableResources,
    showResourceUnavailabilityWarningModal,
    setShowResourceUnavailabilityWarningModal,
    jobSiteSearchTerm,
    setJobSiteSearchTerm,
    selectedCustomerName,
    setSelectedCustomerName,
    crewFields,
    setCrewFields,
    selectedEquipment,
    setSelectedEquipment,
    selectedClass,
    setSelectedClass,
    selectedType,
    setSelectedType,
    selectedSize,
    setSelectedSize,
    equipmentSearchTerm,
    equipmentDebouncedSearchTerm,
    setEquipmentSearchTerm
  };
};
